var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup427320153(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F26639"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4717 12.3C10.8859 12.8858 9.93613 12.8858 9.35035 12.3L8.2797 11.229C8.09256 11.0353 8.09256 10.7281 8.2797 10.5343C8.47154 10.3357 8.78807 10.3302 8.9867 10.522L9.90702 11.4424L9.90002 6.90002C9.90002 6.62388 10.1239 6.40002 10.4 6.40002C10.6762 6.40002 10.9 6.62388 10.9 6.90002L10.9077 11.4497L11.8354 10.5224C11.8394 10.5182 11.8435 10.5141 11.8476 10.5101C12.0463 10.3182 12.3628 10.3237 12.5546 10.5224C12.7465 10.721 12.741 11.0375 12.5424 11.2294L11.4717 12.3L11.4717 12.3ZM13.4 11.7334C13.4 11.4572 13.6239 11.2334 13.9 11.2334C14.1762 11.2334 14.4 11.4572 14.4 11.7334V13.2637C14.3993 13.891 13.891 14.3993 13.2637 14.4H7.53635C6.90909 14.3993 6.40076 13.891 6.40002 13.2637V11.7334C6.40002 11.4572 6.62388 11.2334 6.90002 11.2334C7.17616 11.2334 7.40002 11.4572 7.40002 11.7334V13.2637C7.4002 13.3389 7.46113 13.3998 7.53635 13.4H13.2637C13.3389 13.3998 13.3998 13.3389 13.4 13.2637V11.7334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427320153);
export default __webpack_public_path__ + "static/media/Group 427320153.3a68487bacb6fd988b5fd842a265310f.svg";
export { ForwardRef as ReactComponent };